import React, { useCallback, useState } from "react";

export type FormField<Element> = {
  initialValue: string;
  isFocus: boolean;
  isValid: boolean;
  onBlur: () => void;
  onChange: (e: React.ChangeEvent<Element>) => void; // eslint-disable-line no-unused-vars
  onFocus: () => void;
  setIsValid: React.Dispatch<boolean>;
  setValue: (value: string) => void; // eslint-disable-line no-unused-vars
  value: string;
};

function useFormField<Element extends HTMLInputElement | HTMLSelectElement>(
  initialValue: string = ""
): FormField<Element> {
  const [value, setValue] = useState(initialValue);
  const [isFocus, setIsFocus] = useState(false);
  const [isValid, setIsValid] = useState(true);

  const onChange = useCallback((e: React.ChangeEvent<Element>) => {
    setIsValid(true);
    setValue(e.target.value);
  }, []);

  const onFocus = useCallback(() => {
    setIsFocus(true);
  }, []);

  const onBlur = useCallback(() => {
    setIsFocus(false);
  }, []);

  return { value, onChange, onFocus, onBlur, isFocus, isValid, setIsValid, initialValue, setValue };
}

export { useFormField };
